import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { CoreMediaService } from '../../../../../@core/services/media.service';
import { SubdomainInfo } from '../../../../core/models/subdomain-info';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CategoriesRequest } from '../../../../core/requests/CategoriesRequest';
import { GetAllFilteredCategoriesResponse } from '../../../../core/responses/GetAllFilteredCategoriesResponse';
import { HttpErrorResponse } from '@angular/common/http';
import { CategoriesService } from '../../../../core/service/categories.service';
import { Router } from '@angular/router';
import { PricingPlan } from '../../../../core/helpers/constants';
import { BaseFilterContainerComponent } from 'app/core/filter-system';
import { FilterManagerService } from 'app/core/filter-system';
import { takeUntil } from 'rxjs/operators';
import {AuthenticationService} from "../../../../core/service";

@Component({
  selector: 'app-benefits-filter',
  templateUrl: './benefits-filter.component.html',
  styleUrls: ['./benefits-filter.component.scss'],
  providers: [TranslatePipe],
})

export class BenefitsFilterComponent extends BaseFilterContainerComponent implements OnChanges {
  public filteredCategoriesTree: any[];
  showBudgets = false;
  allCategories: any[] = [];

  @Input() userCompanyInfo: SubdomainInfo;
  @Input() providerId?: number;
  @Input() eventId?: number;
  @Input() applyFiltersBtnEnabled: boolean = false;

  constructor(
    mediaObserver: MediaObserver,
    coreMediaService: CoreMediaService,
    translateService: TranslateService,
    router: Router,
    filterManager: FilterManagerService,
    private authenticationService: AuthenticationService,
    private categoriesService: CategoriesService,
  ) {
    super(mediaObserver, coreMediaService, translateService, router, filterManager);
  }

  getQueryParamKeys(): string[] {
    return ['tax_category', 'budgets', 'benefit_category', 'locations'];
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.showBudgets = this.userCompanyInfo.hasTransportBudget || this.userCompanyInfo.hasProfessionalDevelopmentBudget;
    this.getCategories();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.benefitCategories && changes.benefitCategories.previousValue !== changes.benefitCategories.currentValue) {
      this.filteredCategoriesTree = this.buildTree(this.allCategories);
    }
    if (changes.itemCount && changes.itemCount.previousValue !== changes.itemCount.currentValue) {
      this.itemCount = changes.itemCount.currentValue;
    }
  }

  // --- Domain-specific category tree logic ---

  public getCategories(): void {
    const params: CategoriesRequest = {
      paginationCriteria: {
        start: 0,
        limit: 1000,
      },
      bringAll: true,
      companyId: this.authenticationService.currentUserValue.companyId,
      providerId: this.providerId,
      eventId: this.eventId,
      isAscending: true,
      orderProperty: 'Name',
    };
    this.categoriesService
      .getFilteredCategories(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => this.onGetCategoriesSuccess(data),
        (error) => this.onGetCategoriesFail(error)
      );
  }

  public onGetCategoriesSuccess(data: GetAllFilteredCategoriesResponse): void {
    this.allCategories = data.responseObject.data;
    this.filteredCategoriesTree = this.buildTree(this.allCategories);
  }

  public onGetCategoriesFail(error: HttpErrorResponse): void {}

  public buildTree(data: any[]): any[] {
    const tree: any[] = [];
    const index: { [key: number]: any } = {};

    data.forEach((node) => {
      index[node.id] = { ...node, children: [] };
    });

    data.forEach((node) => {
      if (node.parentId === null) {
        tree.push(index[node.id]);
      } else {
        if (index[node.parentId]) {
          index[node.parentId].children.push(index[node.id]);
        }
      }
    });
    return tree;
  }

  readonly PricingPlan = PricingPlan;
}
